import { IDialogueConfig } from "../types";
/**
 * 这里是小屋，角色们交谈、生活的地方
点击屏幕中的角色可以让视角跟随他们移动
【成员】
	在成员中，可以通过点击【管理成员】将角色从小屋中移入/移出，按照你的想法为角色们创造聚会或独处的机会
	点击角色，可以了解这个角色的状态和想法，并决定是否允许角色产生新的想法
【关系】
	这里你可以按照想象中的设定，为角色设置关系
【情景】
	为角色们的想法和聊天内容创造话题，就可以在这里设置情景，角色们将根据情景产生想法和谈话内容
【对话】
	在对话中，可以浏览小屋中发生过的全部对话
最后欢迎来到小屋，和你的角色们好好生活吧
 */
export const houseIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【小屋】",
      content:
        "这里是小屋，角色们交谈、生活的地方\n-点击屏幕中的角色可以让视角跟随他们移动\n-拖动屏幕可以移动视角",
    },
  ],
};

export const membershipIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【成员】",
      content:
        "在成员中，可以将伙伴从小屋中移入/移出，按照你的想法为角色们创造聚会或独处的机会",
    },
    {
      content:
        "点击角色，可以了解这个角色的状态和想法，并决定是否允许角色产生新的想法",
    },
  ],
};

export const relationsipIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【关系】",
      content: "这里你可以按照想象中的设定，为角色设置关系",
    },
  ],
};

export const dialogueIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【对话】",
      content: "在对话中，可以浏览小屋中发生过的全部对话;",
    },
    {
      content:
        "如果为角色们的想法和聊天内容创造话题，就可以在这里设置，角色们将根据话题产生想法和谈话内容",
    },
  ],
};

export const eventIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【事件】",
      content:
        "这里可以探索一些特定故事和事件，看看角色们会如何应对各种突发状况，",
    },
  ],
};

export const interactionIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【互动】",
      content:
        "在这里可以让角色外派, 或允许Ta主动申请写信/发饼友圈，在这些互动中Ta甚至可能结识来自其他宇宙的伙伴",
    },
  ],
};

export const endIntro: IDialogueConfig = {
  sentences: [
    {
      charName: "【小屋】",
      content: "最后欢迎来到小屋，和你的角色们好好生活吧",
    },
  ],
};
